export const CERTIN_CONTROLS = [
  {
    controlId: "CERT-01",
    category: "Incident Reporting",
    controlRequirement: "Report cyber incidents to CERT-In within 6 hours",
    reportingTimeline: "6 hours",
    logTypesCovered: "All incident types",
    retentionRequirement: "-",
    evidenceRequired: "Incident report, Timeline, Communication proof",
    responsibleFunction: "CISO",
    verificationMethod: "Submission verification",
    automationApproach: "SOAR integration",
    severity: "Critical",
  },
  {
    controlId: "CERT-02",
    category: "Incident Reporting",
    controlRequirement: "Targeted scanning/probing of critical systems",
    reportingTimeline: "6 hours",
    logTypesCovered: "IDS/IPS logs, Firewall logs",
    retentionRequirement: "-",
    evidenceRequired: "Detection evidence, Scope assessment",
    responsibleFunction: "SOC Manager",
    verificationMethod: "Log review",
    automationApproach: "Automated alert triage",
    severity: "High",
  },
  {
    controlId: "CERT-03",
    category: "Incident Reporting",
    controlRequirement: "Compromise of critical systems or information",
    reportingTimeline: "6 hours",
    logTypesCovered: "System logs, Access logs, Malware analysis",
    retentionRequirement: "-",
    evidenceRequired: "Forensic report, Impact assessment",
    responsibleFunction: "CISO",
    verificationMethod: "IR drill",
    automationApproach: "SOAR playbook",
    severity: "Critical",
  },
  {
    controlId: "CERT-04",
    category: "Incident Reporting",
    controlRequirement: "Unauthorized access to IT systems or data",
    reportingTimeline: "6 hours",
    logTypesCovered: "Authentication logs, Access logs",
    retentionRequirement: "-",
    evidenceRequired: "Access evidence, User identification",
    responsibleFunction: "Security Lead",
    verificationMethod: "Log analysis",
    automationApproach: "SIEM correlation",
    severity: "Critical",
  },
  {
    controlId: "CERT-05",
    category: "Incident Reporting",
    controlRequirement: "Defacement of websites or applications",
    reportingTimeline: "6 hours",
    logTypesCovered: "Web server logs, CDN logs",
    retentionRequirement: "-",
    evidenceRequired: "Screenshots, Change evidence",
    responsibleFunction: "App Owner",
    verificationMethod: "Website monitoring",
    automationApproach: "Integrity monitoring",
    severity: "High",
  },
  {
    controlId: "CERT-06",
    category: "Incident Reporting",
    controlRequirement: "Malicious code attacks (virus, ransomware)",
    reportingTimeline: "6 hours",
    logTypesCovered: "Endpoint logs, AV/EDR alerts",
    retentionRequirement: "-",
    evidenceRequired: "Malware sample, Spread analysis",
    responsibleFunction: "SOC Manager",
    verificationMethod: "EDR review",
    automationApproach: "Automated reporting",
    severity: "Critical",
  },
  {
    controlId: "CERT-07",
    category: "Incident Reporting",
    controlRequirement: "Attacks on servers and network equipment",
    reportingTimeline: "6 hours",
    logTypesCovered: "Server logs, Network device logs",
    retentionRequirement: "-",
    evidenceRequired: "Attack evidence, Device status",
    responsibleFunction: "Network Lead",
    verificationMethod: "Device inspection",
    automationApproach: "NDR integration",
    severity: "High",
  },
  {
    controlId: "CERT-08",
    category: "Incident Reporting",
    controlRequirement: "Identity theft, spoofing, phishing",
    reportingTimeline: "6 hours",
    logTypesCovered: "Email logs, DNS logs",
    retentionRequirement: "-",
    evidenceRequired: "Phishing evidence, Impact assessment",
    responsibleFunction: "Security Lead",
    verificationMethod: "Email analysis",
    automationApproach: "Anti-phishing platform",
    severity: "High",
  },
  {
    controlId: "CERT-09",
    category: "Incident Reporting",
    controlRequirement: "Denial of Service attacks",
    reportingTimeline: "6 hours",
    logTypesCovered: "Network flow data, WAF logs",
    retentionRequirement: "-",
    evidenceRequired: "Traffic analysis, Mitigation evidence",
    responsibleFunction: "Network Lead",
    verificationMethod: "Traffic analysis",
    automationApproach: "DDoS mitigation",
    severity: "High",
  },
  {
    controlId: "CERT-10",
    category: "Incident Reporting",
    controlRequirement: "Data breach affecting personal information",
    reportingTimeline: "6 hours",
    logTypesCovered: "Database logs, Application logs",
    retentionRequirement: "-",
    evidenceRequired: "Breach scope, Affected records",
    responsibleFunction: "DPO/CISO",
    verificationMethod: "Data flow analysis",
    automationApproach: "DLP alerts",
    severity: "Critical",
  },
  {
    controlId: "CERT-11",
    category: "Incident Reporting",
    controlRequirement: "Attacks on critical infrastructure",
    reportingTimeline: "6 hours",
    logTypesCovered: "OT logs, SCADA logs",
    retentionRequirement: "-",
    evidenceRequired: "Attack evidence, System status",
    responsibleFunction: "OT Lead",
    verificationMethod: "OT security review",
    automationApproach: "OT SIEM",
    severity: "Critical",
  },
  {
    controlId: "CERT-12",
    category: "Incident Reporting",
    controlRequirement: "Attacks on applications (web, mobile)",
    reportingTimeline: "6 hours",
    logTypesCovered: "Application logs, WAF logs",
    retentionRequirement: "-",
    evidenceRequired: "Attack evidence, Impact",
    responsibleFunction: "App Owner",
    verificationMethod: "App security review",
    automationApproach: "WAF integration",
    severity: "High",
  },
  {
    controlId: "CERT-13",
    category: "Incident Reporting",
    controlRequirement: "Attacks on digital payment systems",
    reportingTimeline: "6 hours",
    logTypesCovered: "Payment logs, Transaction logs",
    retentionRequirement: "-",
    evidenceRequired: "Transaction evidence",
    responsibleFunction: "Payment Lead",
    verificationMethod: "Payment security review",
    automationApproach: "Fraud detection",
    severity: "Critical",
  },
  {
    controlId: "CERT-14",
    category: "Incident Reporting",
    controlRequirement: "Unauthorized cryptocurrency mining",
    reportingTimeline: "6 hours",
    logTypesCovered: "Endpoint logs, Server logs",
    retentionRequirement: "-",
    evidenceRequired: "Detection evidence",
    responsibleFunction: "SOC Manager",
    verificationMethod: "Crypto detection",
    automationApproach: "EDR crypto detection",
    severity: "Medium",
  },
  {
    controlId: "CERT-15",
    category: "Log Retention",
    controlRequirement: "Maintain ICT system logs for 180 days rolling",
    reportingTimeline: "-",
    logTypesCovered:
      "Firewall, IDS/IPS, Proxy, Email, Endpoint, App, DB, Cloud",
    retentionRequirement: "180 days",
    evidenceRequired: "Log retention proof, Storage capacity",
    responsibleFunction: "IT Head",
    verificationMethod: "Log retrieval test",
    automationApproach: "SIEM retention config",
    severity: "Critical",
  },
  {
    controlId: "CERT-16",
    category: "Log Retention",
    controlRequirement: "Logs must be within Indian jurisdiction",
    reportingTimeline: "-",
    logTypesCovered: "All log types",
    retentionRequirement: "180 days",
    evidenceRequired: "Data residency proof",
    responsibleFunction: "IT Head",
    verificationMethod: "Storage location audit",
    automationApproach: "Geo-restricted logging",
    severity: "High",
  },
  {
    controlId: "CERT-17",
    category: "Log Retention",
    controlRequirement: "Logs to be provided to CERT-In on demand",
    reportingTimeline: "-",
    logTypesCovered: "All log types",
    retentionRequirement: "180 days",
    evidenceRequired: "Log export capability",
    responsibleFunction: "CISO",
    verificationMethod: "Export drill",
    automationApproach: "Automated log packaging",
    severity: "High",
  },
  {
    controlId: "CERT-18",
    category: "Time Sync",
    controlRequirement: "Synchronize ICT system clocks to NTP servers",
    reportingTimeline: "-",
    logTypesCovered: "All systems",
    retentionRequirement: "-",
    evidenceRequired: "NTP config, Sync status",
    responsibleFunction: "IT Head",
    verificationMethod: "Time variance check",
    automationApproach: "NTP monitoring",
    severity: "High",
  },
  {
    controlId: "CERT-19",
    category: "Time Sync",
    controlRequirement: "Connect to NIC or NPL NTP servers",
    reportingTimeline: "-",
    logTypesCovered: "All systems",
    retentionRequirement: "-",
    evidenceRequired: "NTP source config",
    responsibleFunction: "IT Head",
    verificationMethod: "NTP source verification",
    automationApproach: "Config compliance",
    severity: "Medium",
  },
  {
    controlId: "CERT-20",
    category: "POC",
    controlRequirement: "Designate Point of Contact for CERT-In liaison",
    reportingTimeline: "-",
    logTypesCovered: "-",
    retentionRequirement: "-",
    evidenceRequired: "POC nomination, Contact details",
    responsibleFunction: "MD/CEO",
    verificationMethod: "POC verification",
    automationApproach: "-",
    severity: "High",
  },
  {
    controlId: "CERT-21",
    category: "MSP/Cloud",
    controlRequirement: "Service providers maintain logs for customers",
    reportingTimeline: "-",
    logTypesCovered: "Customer-related logs",
    retentionRequirement: "180 days",
    evidenceRequired: "MSP agreement, Log access proof",
    responsibleFunction: "Vendor Manager",
    verificationMethod: "MSP audit",
    automationApproach: "API-based retrieval",
    severity: "High",
  },
];
